var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video_svg__a)",
    filter: "url(#video_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#99CAE1",
    stroke: "url(#video_svg__c)",
    strokeLinecap: "round",
    d: "M16.562 5.458h-.145c-2.497 0-4.485 0-6.09.131-1.645.135-3.051.416-4.34 1.073a11.04 11.04 0 0 0-4.825 4.825c-.657 1.289-.938 2.695-1.073 4.34-.13 1.605-.13 3.593-.13 6.09v.166c0 2.497 0 4.485.13 6.09.135 1.645.416 3.051 1.073 4.34a11.04 11.04 0 0 0 4.825 4.825c1.289.657 2.695.938 4.34 1.072 1.605.132 3.593.132 6.09.132h.166c2.497 0 4.486 0 6.09-.132 1.645-.134 3.051-.415 4.34-1.072a11.04 11.04 0 0 0 4.885-4.946c1.93.841 3.57 1.537 4.93 1.906 1.564.424 3.212.547 4.706-.431s2.043-2.537 2.28-4.14c.228-1.538.228-3.548.228-5.945v-3.564c0-2.397 0-4.407-.228-5.944-.237-1.604-.785-3.163-2.28-4.14-1.494-.979-3.142-.856-4.707-.432-1.36.369-3 1.065-4.929 1.906l-.06-.12-.445.226.445-.227a11.04 11.04 0 0 0-4.825-4.825c-1.289-.657-2.695-.938-4.34-1.073-1.605-.13-3.593-.13-6.09-.13z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#video_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#video_svg__e)",
    fillRule: "evenodd",
    d: "M16.583 13.952c.86.422 1.904 1.065 3.182 1.851l.12.075c1.28.787 2.323 1.429 3.096 2.01.784.591 1.464 1.244 1.83 2.118a5.2 5.2 0 0 1 0 3.988c-.366.874-1.046 1.527-1.83 2.117-.773.582-1.816 1.224-3.095 2.011l-.121.075c-1.278.786-2.322 1.428-3.182 1.852-.864.424-1.764.745-2.712.639-1.37-.154-2.585-.916-3.362-2.056-.528-.774-.712-1.714-.798-2.713-.086-.996-.086-2.272-.086-3.853v-.132c0-1.58 0-2.857.086-3.853.086-1 .27-1.939.798-2.713.777-1.14 1.993-1.902 3.362-2.056.947-.106 1.848.215 2.712.64m-2.406 2.093c.144-.016.455.011 1.193.374.729.359 1.66.93 3.015 1.764 1.353.833 2.284 1.408 2.941 1.902.657.495.865.786.947.98a2.44 2.44 0 0 1 0 1.87c-.082.194-.29.485-.947.98-.657.494-1.588 1.07-2.941 1.902-1.354.834-2.286 1.405-3.015 1.764-.738.363-1.049.39-1.193.374-.534-.06-1.048-.362-1.396-.872-.117-.173-.255-.525-.33-1.4-.075-.863-.076-2.02-.076-3.683s.001-2.82.076-3.683c.075-.875.213-1.227.33-1.4.348-.51.862-.812 1.396-.872",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "video_svg__c",
    x1: 0.458,
    x2: 31.221,
    y1: 5.958,
    y2: 47.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "video_svg__e",
    x1: 17.548,
    x2: 41.385,
    y1: 34.419,
    y2: 13.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video_svg__b",
    width: 93.083,
    height: 82.083,
    x: -24.542,
    y: -19.042,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "video_svg__d",
    width: 31.583,
    height: 33.417,
    x: 6.625,
    y: 10.292,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_4634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "video_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export { SvgVideo as ReactComponent };